import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Изменили селекторы: теперь они таргетируют .nav-custom-link вместо всех тегов a
const activeNavLinkAfterStyle = `
  .nav-custom-link.active-nav-link::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #ef4444, #dc2626);
    transform: scaleX(1);
    transition: transform 0.3s ease;
  }
  
  .nav-custom-link:not(.active-nav-link)::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #ef4444, #dc2626);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }
  
  .nav-custom-link:not(.active-nav-link):hover::after {
    transform: scaleX(0.5);
  }
`;

const NavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLinksOpen, setIsLinksOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const styleElement = document.createElement('style');
    styleElement.innerHTML = activeNavLinkAfterStyle;
    document.head.appendChild(styleElement);

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.head.removeChild(styleElement);
    };
  }, []);

  const getNavLinkClass = (path) => {
    // Добавили класс nav-custom-link, чтобы стили применялись только к этим ссылкам
    const baseClass = "text-white hover:text-gray-300 transition-colors relative nav-custom-link";
    const isActive = location.pathname === path || (path === '/' && location.pathname === '');
    return isActive ? `${baseClass} active-nav-link` : baseClass;
  };

  return (
      <nav
          className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
              isScrolled ? 'bg-black bg-opacity-80 backdrop-filter backdrop-blur-lg py-4' : 'bg-transparent py-6'
          }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <Link
                to="/"
                className="text-2xl font-bold logo"
            >
              Xfeatures
            </Link>

            <button
                className="md:hidden text-white focus:outline-none"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>

            <div className="hidden md:flex items-center space-x-8">
              <Link to="/features" className={getNavLinkClass('/features')}>Возможности</Link>
              <Link to="/hosting" className={getNavLinkClass('/hosting')}>Хостинг</Link>
              <Link to="/projects" className={getNavLinkClass('/projects')}>Проекты</Link>
              <Link to="/about" className={getNavLinkClass('/about')}>О нас</Link>
              <Link to="/support" className={getNavLinkClass('/support')}>Поддержка</Link>


            </div>
          </div>

          <div className={`md:hidden transition-all duration-300 overflow-hidden ${isMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'}`}>
            <div className="flex flex-col space-y-4 py-4">
              <Link to="/features" className={`${getNavLinkClass('/features')} py-2`} onClick={() => setIsMenuOpen(false)}>Возможности</Link>
              <Link to="/hosting" className={`${getNavLinkClass('/hosting')} py-2`} onClick={() => setIsMenuOpen(false)}>Хостинг</Link>
              <Link to="/projects" className={`${getNavLinkClass('/projects')} py-2`} onClick={() => setIsMenuOpen(false)}>Проекты</Link>
              <Link to="/about" className={`${getNavLinkClass('/about')} py-2`} onClick={() => setIsMenuOpen(false)}>О нас</Link>
              <Link to="/support" className={`${getNavLinkClass('/support')} py-2`} onClick={() => setIsMenuOpen(false)}>Поддержка</Link>
            </div>
          </div>
        </div>
      </nav>
  );
};

export default NavBar;